/* Countdown to the nearest event from the data-events list (start/end, ISO 8601).
 *   - before an event  -> counts down to its start
 *   - during an event  -> start is in the past, so Tick clamps the timer to all zeros
 *   - after all events -> banner hidden
 * When the ongoing event ends the next event is picked up on the following page load.
 * Initialized by Tick.js (data-did-init="handleSummerEventCountdownInit").
 */

function handleSummerEventCountdownInit(tick) {
  const root = tick.root.closest("[data-summer-event-countdown]");
  if (!root || !window.Tick) {
    return;
  }

  const actionBtn = root.closest("[data-summer-event-cd-action]");
  if (!actionBtn) {
    return;
  }

  const now = Date.now();
  const events = JSON.parse(root.getAttribute("data-events") || "[]");

  const event = events
    .filter((e) => new Date(e.end).getTime() > now)
    .sort((a, b) => new Date(a.start) - new Date(b.start))[0];

  if (!event) {
    return;
  }

  root.classList.add("summerEventCountdown--upcoming");

  const locale = {
    DAY_PLURAL: "dni",
    DAY_SINGULAR: "dzień",
    HOUR_PLURAL: "godzin",
    HOUR_SINGULAR: "godzina",
    MINUTE_PLURAL: "minut",
    MINUTE_SINGULAR: "minuta",
    SECOND_PLURAL: "sekund",
    SECOND_SINGULAR: "sekunda",
  };
  Object.entries(locale).forEach(([key, value]) =>
    tick.setConstant(key, value),
  );

  const counter = window.Tick.count.down(event.start);
  counter.onupdate = (value) => {
    tick.value = value;
  };
}
